class Carousel {
  constructor( el ) {
    this.carouselel = el;
    this.carouselinnerel = this.carouselel.querySelector('.carousel-inner');
    this.carouselnextbuttons = this.carouselel.querySelectorAll('.carousel-control-next');
    this.carouselprevbuttons = this.carouselel.querySelectorAll('.carousel-control-prev');
    this.currentitem =  this.carouselel.querySelector('.carousel-item');
    this.currentitem.classList.add('current');
  }

  async scrollTo( scrollOriginalPosition, scrollDestPosition ){
    this.carouselinnerel.scrollLeft = scrollDestPosition;
    requestAnimationFrame(scroll);
  }

  async initNextEvents(){
    let Carousel = this;
    this.carouselnextbuttons.forEach((nextbutton) => {
      nextbutton.addEventListener( 'click', (e) => {
        if( !nextbutton.classList.contains('disabled') && Carousel.currentitem.nextElementSibling ){
          let carouselScrollWidth = parseInt(Carousel.carouselinnerel.scrollWidth);
          let carouselOffsetWidth = parseInt(Carousel.carouselinnerel.offsetWidth);
          let firstEl = Carousel.carouselinnerel.querySelector(".carousel-item");
          let scrollFrom = ( Carousel.currentitem.offsetLeft - firstEl.offsetLeft );
          let scrollTo = ( Carousel.currentitem.nextElementSibling.offsetLeft - firstEl.offsetLeft );
          let maxScrollTo = carouselScrollWidth - carouselOffsetWidth;

          this.carouselprevbuttons.forEach((prevbutton) => {
            prevbutton.classList.remove('disabled');
          });
          Carousel.scrollTo( scrollFrom, ( (Carousel.currentitem.nextElementSibling.offsetLeft <= maxScrollTo)? scrollTo : maxScrollTo ) );
          
          Carousel.currentitem = Carousel.currentitem.nextElementSibling;
          [... Carousel.carouselinnerel.querySelectorAll('.carousel-item')].map( item => {
            item.classList.remove('current');
          });
          Carousel.currentitem.classList.add('current');
          
          if( scrollTo >= maxScrollTo  ){
            this.carouselnextbuttons.forEach((nextbutton) => {
              nextbutton.classList.add('disabled');
            });
          }
        }
      });
    });
  }

  async initPrevEvents(){
    let Carousel = this;
    this.carouselprevbuttons.forEach((prevbutton) => {
      prevbutton.addEventListener( 'click', (e) => {
        if( !prevbutton.classList.contains('disabled') ){

          let firstEl = Carousel.carouselinnerel.querySelector(".carousel-item");
          if( Carousel.currentitem.previousElementSibling ){
  
            this.carouselnextbuttons.forEach((nextbutton) => {
              nextbutton.classList.remove('disabled');
            });

            Carousel.scrollTo( ( Carousel.currentitem.offsetLeft - firstEl.offsetLeft ), ( Carousel.currentitem.previousElementSibling.offsetLeft - firstEl.offsetLeft ) );
            Carousel.currentitem = Carousel.currentitem.previousElementSibling;
            [... Carousel.carouselinnerel.querySelectorAll('.carousel-item')].map( item => {
              item.classList.remove('current');
            });
            Carousel.currentitem.classList.add('current');

            if( !Carousel.currentitem.previousElementSibling ){
              this.carouselprevbuttons.forEach((prevbutton) => {
                prevbutton.classList.add('disabled');
              });
            }
          }

        }
      });
    });
  }

  async init(){
    this.initNextEvents();
    this.initPrevEvents();
  }
}

DOMReady( function(){
  [... document.querySelectorAll('.carousel')].map( l => {
    let carousel = new Carousel(l);
    carousel.init();
  });
});
